import React from "react";
import { useTranslation } from "react-i18next";

import { BMS_COPAY_LS_HUB_CONTACT_ERROR_CODES } from "../../constants";
import { EnrollFailureHeader, EnrollFailureSupportFooter, TextStyled } from "./EnrollFailureShared";

export const EnrollBmsCopayLsFailure = ({ error }) => {
  const { t } = useTranslation();
  const isHubContactError = BMS_COPAY_LS_HUB_CONTACT_ERROR_CODES.includes(error);

  return (
    <>
      <EnrollFailureHeader error={error} />
      {isHubContactError && <TextStyled>{t("patientApplications.enroll.enroll_result.contact_time_bms")}</TextStyled>}
      <EnrollFailureSupportFooter>
        <TextStyled>
          {t(
            isHubContactError
              ? "patientApplications.enroll.enroll_result.contact_support_tech"
              : "patientApplications.enroll.enroll_result.please_contact_support_with_error"
          )}
        </TextStyled>
      </EnrollFailureSupportFooter>
    </>
  );
};
